import React, { useState, useEffect } from "react";
import { useEmailSections } from "../../Context/EmailSectionContext";
import { addOpacity } from "../../../helpers";
import StyleControls from "./StyleControls";

const Footer = (props) => {
  const { id, previewMode, styleSettings = {}, data } = props;
  const { sections, updateSection } = useEmailSections();

  const sectionData = previewMode
    ? data || props
    : sections.find(section => section.id === id) || {};

  const {
    title = "",
    description = "",
    copyright = "",
    features = [],
    component_name = "Footer"
  } = sectionData;

  const [isEditing, setIsEditing] = useState(false);
  const [localTitle, setLocalTitle] = useState(title);
  const [localDescription, setLocalDescription] = useState(description);
  const [localCopyright, setLocalCopyright] = useState(copyright);
  const [localFeatures, setLocalFeatures] = useState(features);

  useEffect(() => {
    setLocalTitle(title);
    setLocalDescription(description);
    setLocalCopyright(copyright);
    setLocalFeatures(Array.isArray(features) ? features : []);
  }, [id]);

  // Merge section-specific styles with parent styles
  const sectionStyleSettings = sectionData?.styleSettings || {};
  const effectiveStyleSettings = {
    ...styleSettings,  // Parent styles (defaults)
    ...sectionStyleSettings  // Section-specific overrides
  };
  const {
    primaryColor = "#333333",
    secondaryColor = "#a1894c",
    fontFamily = "helvetica, 'helvetica neue', arial, verdana, sans-serif",
    backgroundColor = "#ffffff"
  } = effectiveStyleSettings;

  const handleSave = () => {
    const currentSection = sections.find(section => section.id === id) || {};
    updateSection(id, {
      id,
      component_name,
      title: localTitle,
      description: localDescription,
      copyright: localCopyright,
      features: localFeatures,
      styleSettings: {
        ...(currentSection.styleSettings || {}) // Preserve existing styleSettings
      }
    });
    setIsEditing(false);
  };

  const addFeature = () => setLocalFeatures([...localFeatures, { title: "", link: "", component_name: "Social_Link" }]);
  const updateFeature = (idx, field, value) => {
    const newFeatures = [...localFeatures];
    newFeatures[idx][field] = value;
    setLocalFeatures(newFeatures);
  };
  const removeFeature = (idx) => setLocalFeatures(localFeatures.filter((_, i) => i !== idx));

  if (isEditing && !previewMode) {
    return (
      <div className="email-component footer-editor p-3 mb-3 border rounded">
        <h4>Edit Footer</h4>
        <input className="form-control mb-2" value={localTitle} onChange={e => setLocalTitle(e.target.value)} placeholder="Title" />
        <textarea className="form-control mb-2" value={localDescription} onChange={e => setLocalDescription(e.target.value)} placeholder="Description" />
        <input className="form-control mb-2" value={localCopyright} onChange={e => setLocalCopyright(e.target.value)} placeholder="Copyright" />
        <div className="mb-2">
          <label>Social Links</label>
          {localFeatures.map((feature, idx) => (
            <div key={idx} className="d-flex mb-1">
              <input className="form-control me-2" value={feature.title} onChange={e => updateFeature(idx, "title", e.target.value)} placeholder="Platform" />
              <input className="form-control me-2" value={feature.link} onChange={e => updateFeature(idx, "link", e.target.value)} placeholder="URL" />
              <button className="btn btn-sm btn-outline-danger" onClick={() => removeFeature(idx)}>&times;</button>
            </div>
          ))}
          <button className="btn btn-sm btn-outline-primary mt-2" onClick={addFeature}>+ Add Social Link</button>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-outline-secondary me-2" onClick={() => setIsEditing(false)}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave}>Save Changes</button>
        </div>
      </div>
    );
  }

  // VIEW/PREVIEW
  return (
    <>
      {!previewMode && (
      <div className="email-component footer mb-3">
        <div className="component-controls mb-2 d-flex justify-content-between align-items-center flex-wrap gap-2">
          <StyleControls 
            id={id} 
            componentName={component_name}
            styleSettings={styleSettings}
            previewMode={previewMode}
          />
          <button className="btn btn-sm btn-outline-primary" onClick={() => setIsEditing(true)}>Edit Footer</button>
        </div>
        </div>
      )}
   <table width="100%" cellpadding="0" cellspacing="0" border="0" style={{ fontFamily, backgroundColor }}>
   <tr>
          <td style={{
            backgroundColor: addOpacity(secondaryColor, 0.2),
            color: primaryColor,
            textAlign: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
            padding: '12px',
            fontFamily
          }}>
            {localTitle}
          </td>
        </tr>

        {/* Feature links */}
        <tr>
          <td align="center" style={{ padding: '12px 0', backgroundColor }}>
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                {localFeatures.map((feature, idx) => (
                  <td key={idx} style={{ padding: '0 8px 8px 8px' }}>
                    <a
                      href={feature.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: primaryColor,
                        textDecoration: 'none',
                        fontFamily,
                        fontSize: '14px'
                      }}
                    >
                      {feature.title}
                    </a>
                  </td>
                ))}
              </tr>
            </table>
          </td>
        </tr>

        {/* Footer description */}
        <tr>
          <td align="center" style={{
            padding: '0 16px 16px 16px',
            color: secondaryColor,
            fontSize: '14px',
            fontFamily,
            textAlign: 'center',
            backgroundColor
          }}>
            {localDescription}
          </td>
        </tr>
</table>

 
    </>
  
  );
};

export default Footer;
